<template>
  <layout-base id="gtr-emails-html">
    <!-- INTRO -->
    <report-intro :title="email.data.title" :sub-title="email.data.sub_title" :date="email.data.email_date" />
    <!-- SECTION REPUTATION -->
    <report-reputation :reputation="email.data.reputation" v-if="email.data.reputation" />
    <!-- SECTION COMPETITION -->
    <report-competition :competition="email.data.competition" v-if="email.data.competition" />
    <!-- SECTION PERFORMANCE -->
    <report-performance :performance="email.data.performance" v-if="email.data.performance" />
    <!-- SECTION AUDIENCE -->
    <report-audience :audience="email.data.audience" v-if="email.data.audience" />
    <!-- SECTION RADAR -->
    <report-radar :radar="email.data.radar" v-if="email.data.radar" />
    <!-- FOOTER -->
    <report-footer :pdf="email.data.pdf" :unsubscribe="email.data.unsubscribe" />
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import ReportIntro from '@/components/Report/Intro.vue'
import ReportReputation from '@/components/Report/Reputation.vue'
import ReportCompetition from '@/components/Report/Competition.vue'
import ReportPerformance from '@/components/Report/Performance.vue'
import ReportAudience from '@/components/Report/Audience.vue'
import ReportRadar from '@/components/Report/Radar.vue'
import ReportFooter from '@/components/Report/Footer.vue'

export default {
  name: 'ReportGlobal',
  components: {
    LayoutBase,
    ReportIntro,
    ReportReputation,
    ReportCompetition,
    ReportPerformance,
    ReportAudience,
    ReportRadar,
    ReportFooter,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
